import React from 'react'
import aboutImage from '../../assets/images/about/about-img5.png'
import starIcon from '../../assets/images/icons/star-icon.png'
import open_source_icon from '../../assets/images/icons/opensource_source_icon.svg'
import coverage_icon from '../../assets/images/icons/n_m_coverage_icon.svg'
import code_cognita_icon from '../../assets/images/icons/code_cognita_icon.svg'
import prototype_fund_icon from '../../assets/images/icons/prototype_fund_placeholder_icon.svg'
 
const AboutUsContent = () => {
    return (
        <section className="about-area ptb-100">
            <div className="container-fluid">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-md-12">
                        <div className="about-image">
                            <img src={aboutImage} alt="banner" />
                        </div>
                    </div>

                    <div className="col-lg-6 col-md-12">
                        <div className="about-content">
                            <div className="content">
                                <span className="sub-title">
                                    <img src={starIcon} alt="banner" /> 
                                    About Us
                                </span>
                                <h2>Cover-Rest</h2>
                                <p>Have one Solution for Coverage and Feature localisation</p>
                                
                                <ul className="features-list">
                                    <li>
                                        <img src={open_source_icon} alt="banner" width="50"/>
                                        <h3>Open Source Project</h3>
                                    </li>
                                    <li>
                                        <img src={prototype_fund_icon} alt="banner" width="50"/>
                                        <h3>Prototype Fund</h3>
                                    </li>
                                    <li>
                                        <img src={coverage_icon} alt="banner" width="50"/>
                                        <h3>n:m Coverage</h3>
                                    </li>
                                    <li>
                                        <img src={code_cognita_icon} alt="banner" width="50"/>
                                        <h3>Code Cognita</h3>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* <div className="circle-shape1">
                <img src={shape1} alt="banner" />
            </div>

            <div className="container">
                <div className="about-inner-area">
                    <div className="row">
                        <div className="col-lg-4 col-md-6 col-sm-6">
                            <div className="about-text">
                                <h3>Our History</h3>
                                <p>Real innovations and a positive customer experience are the heart of successful communication.</p>
                                
                                <ul className="features-list">
                                    <li><i className="flaticon-tick"></i> Activate Listening</li>
                                    <li><i className="flaticon-tick"></i> Brilliant minds</li>
                                    <li><i className="flaticon-tick"></i> Better. Best. Wow!</li>
                                    <li><i className="flaticon-tick"></i> Branding it better!</li>
                                </ul>
                            </div>
                        </div>
    
                        <div className="col-lg-4 col-md-6 col-sm-6">
                            <div className="about-text">
                                <h3>Our Mission</h3>
                                <p>Real innovations and a positive customer experience are the heart of successful communication.</p>
                                
                                <ul className="features-list">
                                    <li><i className="flaticon-tick"></i> Creating. Results.</li>
                                    <li><i className="flaticon-tick"></i> Expect more</li>
                                    <li><i className="flaticon-tick"></i> Good thinking</li>
                                    <li><i className="flaticon-tick"></i> In real we trust</li>
                                </ul>
                            </div>
                        </div>
    
                        <div className="col-lg-4 col-md-6 col-sm-6 offset-lg-0 offset-md-3 offset-sm-3">
                            <div className="about-text">
                                <h3>Who we are</h3>
                                <p>Real innovations and a positive customer experience are the heart of successful communication.</p>
                                
                                <ul className="features-list">
                                    <li><i className="flaticon-tick"></i> Stay real. Always.</li>
                                    <li><i className="flaticon-tick"></i> We have you covered</li>
                                    <li><i className="flaticon-tick"></i> We turn heads</li>
                                    <li><i className="flaticon-tick"></i> Your brand, promoted</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="circle-shape1">
                <img src={shape1} alt="banner" />
            </div> */}
        </section>
    )
}

export default AboutUsContent;